import React from "react";
import { Link } from "react-router-dom";
import { EntryLayout } from "../components/entryLayout";
import axios from "axios";

function Login() {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const hostAPI = process.env.REACT_APP_API_BASE_URL || ''

  const handleSubmit = async (e) => {
    e.preventDefault();
    let url = `${hostAPI}/api/v1/auth/jwt/create/`
    try {
      const response = await axios.post(url, { username, password });
      localStorage.setItem("access_token", response.data.access);
      document.cookie = `refresh_token=${response.data.refresh}; path=/; max-age=${60 * 60 * 24 * 14}`;
      window.location.href = "/home"
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <EntryLayout>
      <h4>Welcome back!</h4>
      <h5 className="font-weight-light">Happy to see you again!</h5>
      <form className="pt-3" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputEmail">Username</label>
          <div className="input-group">
            <div className="input-group-prepend bg-transparent">
              <span className="input-group-text bg-transparent border-right-0">
                <i className="mdi mdi-account-outline text-primary"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control form-control-lg border-left-0"
              id="exampleInputEmail"
              placeholder="Username"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPassword">Password</label>
          <div className="input-group">
            <div className="input-group-prepend bg-transparent">
              <span className="input-group-text bg-transparent border-right-0">
                <i className="mdi mdi-lock-outline text-primary"></i>
              </span>
            </div>
            <input
              type="password"
              className="form-control form-control-lg border-left-0"
              id="exampleInputPassword"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>
        <div className="my-2 d-flex justify-content-between align-items-center">
          <div className="form-check">
            <label className="form-check-label text-muted">
              <input type="checkbox" className="form-check-input" />
              Keep me signed in
            </label>
          </div>
          <a href="/#" className="auth-link text-black">
            Forgot password?
          </a>
        </div>
        <div className="my-3">
          <button
            type="submit"
            className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
          >
            LOGIN
          </button>
        </div>
        <div className="text-center mt-4 font-weight-light">
          Don't have an account?{" "}
          <Link to="/register" className="text-primary">
            Create
          </Link>
        </div>
      </form>
    </EntryLayout>
  );
}

export { Login };
